<template>
  <div :class="{ 'border-b broder-bdefault pb-6 rounded': !detailsPage }">
    <div class="text-talternative-color font-bold text-xl md:text-2xl mb-4 flex items-end">
      <v-medical-bag-icon class="medicalbag_cls w-6 h-9 mr-2" />
      {{ data.Header }}
    </div>
    <div class="py-2 bg-white" v-html="data.Text" />
    <div class="mt-2">
      <v-checkbox-group
        class="font-bold"
        :label="data.Footer"
        :inputid="'program-' + index"
        v-model="data.active"
        :initvalue="data.active"
      />
    </div>
  </div>
</template>
<script>
import VCheckboxGroup from '@/components/shared/form/CheckboxGroup';
import VMedicalBagIcon from 'icons/MedicalBag';
import { watch, getCurrentInstance } from 'vue';

export default {
  name: 'CareProgrammmeRow',
  components: {
    VCheckboxGroup,
    VMedicalBagIcon
  },
  props: {
    data: {
      type: Object,
      default: () => {}
    },
    index: {
      type: String,
      required: true
    },
    detailsPage: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    const $emitter = getCurrentInstance().appContext.config.globalProperties.$emitter;
    watch(
      () => props.data.active,
      (newVal, oldVal) => {
        if (newVal !== oldVal) {
          $emitter.emit('careProgramAction', { key: props.index, active: props.data.active });
        }
      },
      { immediate: true }
    );
    return {};
  }
};
</script>
<style lang="scss" scoped>
.medicalbag_cls {
  fill: $teal-darkest;
}
</style>
